import { render, staticRenderFns } from "./WidgetOverview.vue?vue&type=template&id=257cdaf0&scoped=true"
import script from "./WidgetOverview.vue?vue&type=script&lang=js"
export * from "./WidgetOverview.vue?vue&type=script&lang=js"
import style0 from "./WidgetOverview.vue?vue&type=style&index=0&id=257cdaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257cdaf0",
  null
  
)

export default component.exports